/**
 * Mirror of the backend catalogue in server/command/services/rbac/rbac_seeds.py.
 * Keep the two in step: a codename that exists here but not there silently hides UI.
 */
export const PERMISSIONS = {
  PAGE_HOME: "page:home:view",
  PAGE_SHOWS: "page:shows:view",
  PAGE_GUESTS: "page:guests:view",
  PAGE_WAITLIST: "page:waitlist:view",
  PAGE_ORDERS: "page:orders:view",
  PAGE_REQUESTS: "page:requests:view",
  PAGE_PERFORMERS: "page:performers:view",
  PAGE_LOCATIONS: "page:locations:view",
  PAGE_FESTIVALS: "page:festivals:view",
  PAGE_PASSWORDS: "page:passwords:view",
  PAGE_MERCH: "page:merch:view",
  PAGE_PROMOS: "page:promos:view",
  PAGE_CAMPAIGNS: "page:marketing:campaigns:view",
  PAGE_EMAILS: "page:marketing:emails:view",
  PAGE_TEMPLATES: "page:marketing:templates:view",
  PAGE_LINKS: "page:marketing:links:view",
  PAGE_AUTOMATIONS: "page:automations:view",
  PAGE_COMMUNICATIONS: "page:communications:view",
  PAGE_CHECKLISTS: "page:checklists:view",
  PAGE_ANALYTICS: "page:analytics:view",
  PAGE_SETTINGS: "page:settings:view",
  PAGE_SETTINGS_USERS: "page:settings:users:view",
  PAGE_SETTINGS_ROLES: "page:settings:roles:view",

  SHOW_WRITE: "show:write",
  SHOW_DELETE: "show:delete",
  PERFORMER_WRITE: "performer:write",
  LOCATION_WRITE: "location:write",
  FESTIVAL_WRITE: "festival:write",
  PASSWORD_WRITE: "password:write",

  GUEST_WRITE: "guest:write",
  GUEST_CHECKIN: "guest:checkin",
  ORDER_WRITE: "order:write",
  ORDER_REFUND: "order:refund",

  MERCH_WRITE: "merch:write",
  PROMO_WRITE: "promo:write",

  CAMPAIGN_WRITE: "campaign:write",
  CAMPAIGN_SEND: "campaign:send",
  EMAIL_WRITE: "email:write",
  TEMPLATE_WRITE: "template:write",
  LINK_WRITE: "link:write",

  AUTOMATION_WRITE: "automation:write",
  FORM_WRITE: "form:write",
  CONFIG_WRITE: "config:write",
  LOGS_READ: "logs:read",

  RBAC_USERS_READ: "rbac:users:read",
  RBAC_USERS_WRITE: "rbac:users:write",
  RBAC_ROLES_READ: "rbac:roles:read",
  RBAC_ROLES_WRITE: "rbac:roles:write",

  // Money. Super Admin only: rbac_seeds keeps the `finance:` prefix out of the
  // Admin and Read Only roles, which are otherwise built by exclusion.
  FINANCE_PAGE: "finance:page:view",
  FINANCE_EXPENSE_WRITE: "finance:expense:write",
  FINANCE_PLAN_WRITE: "finance:plan:write",
  FINANCE_PLAN_COMMIT: "finance:plan:commit",
  FINANCE_DECISION_WRITE: "finance:decision:write",
  FINANCE_OVERHEAD_WRITE: "finance:overhead:write",
} as const;

export type PermissionCode = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

export const SUPER_ADMIN_ROLE_NAME = "Super Admin";
